import iconUrl from "@/assets/recycling/echartsMap/close.svg";
import companyUrl from "../../../public/home/compony.svg";

let videoData = {
    title: '监控视频',
    src: '',
    poster: require('../../../public/home/bg4.jpg'),
    width: 560,
    height: 250,
};

export  const dom1 = `
                    <div style='width:200px;height:300px;background:rgba(8,58,109,0.7);box-shadow:inset 2px 2px 10px  #1AFFFB, 4px 4px 16px  #002740;backdrop-filter: blur(4px);' id="echartsMap">
                        <div style="display: flex;align-items: center;justify-content: space-between;padding: 0 10px">
                          <div id="cityName" style="width:150px;height:45px;text-align: start;line-height: 45px;font-size: 14px;"></div>
                          <img onclick="remove(this)" style="cursor: pointer;width: 10px" src="${iconUrl}" alt="关闭">
                        </div>
                        <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #96FDFF 0%, #00ABAD 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div style="margin-left: 8px;font-size: 16px;">回收网点</div>
                          </div>
                          <div id="recycleStation" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                        <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #A1DEFF 0%, #00A6FF 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div style="margin-left: 8px;font-size: 16px;">中转站</div>
                          </div>
                          <div id="transferStation" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                         <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #CBB5FF 0%, #7033FF 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div style="margin-left: 8px;font-size: 16px;">分拣中心</div>
                          </div>
                          <div id="sortingCenter" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                         <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #A6BFFF 0%, #2462FF 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div style="margin-left: 8px;font-size: 16px;">利废企业</div>
                          </div>
                          <div id="wasteEnterprise" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                         <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #A6BFFF 0%, #2462FF 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div id="tradingMarket" style="margin-left: 8px;font-size: 16px;">二手交易市场</div>
                          </div>
                          <div id="dismantlingCenter" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                         <div style="height: 30px;display: flex;padding: 0 20px;margin-top: 10px;">
                          <div style="display: flex;flex:1;align-items: center;">
                           <div style="width: 10px;height: 10px;border-radius: 50%;background: radial-gradient(30% 40% at 30% 20%, #A6BFFF 0%, #2462FF 100%);box-shadow:inset 0px 0px 2px  #FFFFFF;"></div>
                           <div style="margin-left: 8px;font-size: 16px;">产业园区</div>
                          </div>
                          <div id="industrialPark" style="flex: 1;display: flex;justify-content: end;align-items: center;color: #00EEFF;font-size: 16px;">0个</div>
                        </div>
                  </div>
                  `;
export const dom2 = `
              <div style="cursor:pointer;padding:20px;opacity: 1;border-radius: 3.13px;background: #044069eb;box-shadow:inset 2px 2px 10px  #1AFFFB, 4px 4px 16px  #002740;backdrop-filter: blur(4px)">
                <div>
                  <div style="display: flex;justify-content: space-between">
                      <div style="font-size: 18px;font-weight: 700">企业详情</div>
                      <img onclick="remove(this)" style="width: 12px;cursor: pointer" src="${iconUrl}" alt="">
                  </div>
                </div>
                <div style="max-height: 600px;overflow-y: auto;overflow-x: hidden">
                     <div style="margin-top: 35px;display: flex">
                          <img style="width: 100px;margin-right: 20px" src="${companyUrl}" alt="">
                          <div>
                              <div id="componyName" style="font-size: 20px;margin-bottom: 15px;font-weight: 500"></div>
                              <div id="legalPerson" style="font-size: 14px;margin-bottom: 5px;height: 20px"></div>
                              <div id="contact" style="font-size: 14px;margin-bottom: 5px;height: 20px"></div>
                              <div id="address" style="font-size: 14px;margin-bottom: 5px;height: 20px"></div>
                          </div>
                     </div>
                    <div style="margin-top: 30px;display: flex;justify-content: space-between">
                         <div style="width: 259.19px;height: 100px;opacity: 1;border-radius: 3.13px;border:1px solid #1AFFFB;display: flex;justify-content: center;align-items: center">
                           <div>
                             <div style="font-size: 32px;height: 45px;width: 80px;line-height: 45px;text-align: center;color: rgba(0, 238, 255, 1);font-weight: 700">-</div>
                             <div style="width: 80px;height: 21px;font-size: 14px;text-align: center;font-weight: 500">—</div>
                           </div>
                         </div>
                         <div style="width: 259.19px;height: 100px;opacity: 1;border-radius: 3.13px;border:1px solid #1AFFFB;display: flex;justify-content: center;align-items: center">
                           <div>
                             <div style="font-size: 32px;height: 45px;width: 80px;line-height: 45px;text-align: center;color: rgba(0, 238, 255, 1);font-weight: 700">-</div>
                             <div style="width: 80px;height: 21px;font-size: 14px;text-align: center;font-weight: 500">—</div>
                           </div>
                         </div>
                    </div>
                    <div>
                      <h2 style="padding: 20px 0">${videoData.title}</h2>
                      <video
                        width="${videoData.width}"
                        id="echartsMp4"
                        height="${videoData.height}"
                        poster="${videoData.poster}"
                        controls
                      >
                        <source id="source" src="${videoData.src}" type="video/mp4">
                        您的浏览器不支持 HTML5 视频
                      </video>
                    </div>
                    <div>
                        <h2 style="padding: 20px 0">股份占比</h2>
                        <div id="SharesPie" style="width: inherit;height: 250px;margin-bottom: 20px"></div>
                    </div>
                </div>
            </div>
            `;
